/**
 * Tag colors for extraction-question options. Order is fixed so the same
 * option index always gets the same color in the report UI and when AI
 * report plans persist new options.
 */
export const QUESTION_OPTION_COLOR_PALETTE = [
  '#B388FF',
  '#64B5F6',
  '#FF8A65',
  '#F48FB1',
  '#90CAF9',
  '#4DD0E1',
  '#BA68C8',
  '#AED581',
  '#FFB74D',
  '#81D4FA',
  '#CE93D8',
  '#A5D6A7',
  '#FFF176',
  '#80CBC4',
  '#FFAB91',
] as const;

export function colorForQuestionOption(order: number): string {
  return QUESTION_OPTION_COLOR_PALETTE[order % QUESTION_OPTION_COLOR_PALETTE.length];
}
